import { render, staticRenderFns } from "./SurveySuggestion.vue?vue&type=template&id=21e2e7a8&scoped=true&"
import script from "./SurveySuggestion.vue?vue&type=script&lang=js&"
export * from "./SurveySuggestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveySuggestion.vue?vue&type=style&index=0&id=21e2e7a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2e7a8",
  null
  
)

export default component.exports